import React from "react";
import { Container } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import {
//   UncontrolledDropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from "reactstrap";

const Welcomegreet = () => {
  return (
    <section className="Welcomegreet_main mt-4">
      <Container fluid>
        <div className="dash_header d-flex align-items-center justify-content-between">
          <div className="welcome_msg_dash text-start">
            <h1>
            Hi admin
              <img src="/images/wave.png" alt="" className="img-fluid wave ms-3" />
            </h1>
            <h2>Welcome Back</h2>
          </div>

        
        </div>
      </Container>
    </section>
  );
};

export default Welcomegreet;
